import { render, staticRenderFns } from "./AttendanceStaggerManage.vue?vue&type=template&id=3906463f&scoped=true"
import script from "./AttendanceStaggerManage.ts?vue&type=script&lang=ts&external"
export * from "./AttendanceStaggerManage.ts?vue&type=script&lang=ts&external"
import style0 from "./AttendanceStaggerManage.vue?vue&type=style&index=0&id=3906463f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906463f",
  null
  
)

export default component.exports